import { AlertTriangle, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { subscribeApiRateLimit } from '../../shared/api-rate-limit';

export function ApiRateLimitSnackbar() {
  const [message, setMessage] = useState('');

  useEffect(() => subscribeApiRateLimit(setMessage), []);
  useEffect(() => {
    if (!message) return;
    const timeout = window.setTimeout(() => setMessage(''), 6_000);
    return () => window.clearTimeout(timeout);
  }, [message]);

  if (!message) return null;
  return (
    <div className="fixed bottom-5 right-5 z-[60] flex w-[min(26rem,calc(100vw-2rem))] items-start gap-3 rounded-md border border-[#e6c56f] bg-[#fff8df] px-4 py-3 text-[#735817] shadow-lg" role="status" aria-live="polite">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1 text-sm font-medium">{message}</p>
      <button type="button" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md hover:bg-[#f4e7b8]" aria-label="Cerrar aviso" title="Cerrar aviso" onClick={() => setMessage('')}>
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
